export const logiApi = "/api/login";
export const registerApi = "/api/register"; // dang ky
export const menuApi = "/api/menus";
export const userInforApi = "/api/userInfo";
